import angular from 'angular';
import { BehaviorSubject } from 'rxjs';
import '../core.module';

let nextNotificationId = 1;

class NotificationService {
  constructor() {
    this.notifications$ = new BehaviorSubject([]);
  }

  push(type, message, options = {}) {
    const notification = {
      id: nextNotificationId++,
      type,
      message,
      timeout: options.timeout ?? 4000
    };
    this.notifications$.next([...this.notifications$.value, notification]);
    return notification.id;
  }

  success(message, options) {
    return this.push('success', message, options);
  }

  error(message, options) {
    return this.push('error', message, options);
  }

  warning(message, options) {
    return this.push('warning', message, options);
  }

  info(message, options) {
    return this.push('info', message, options);
  }

  dismiss(id) {
    this.notifications$.next(
      this.notifications$.value.filter((notification) => notification.id !== id)
    );
  }
}

angular.module('app.core').service('NotificationService', NotificationService);

export default NotificationService;
